import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface GetSettlementCompareDetail {
  date?: string;
}

async function getSettlementCompareDetail(
  data: GetSettlementCompareDetail
): Promise<any> {
  try {
    return (await axiosInstance.post("/Transaction/GetSettlementCompareDetail", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetSettlementCompareDetail() {
  return useMutation<any, Error, GetSettlementCompareDetail>((variables) =>
    getSettlementCompareDetail(variables)
  );
}
